import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { getTeam, getPlayerHistory } from '../../data';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Select, MenuItem, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class SingleTeam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            team: [],
            loading: true,
            leagueID: this.props.match.params.leagueID,
            teamID: this.props.match.params.teamID,
            modalOpen: false,
            modalLoading: false,
            selectedPlayerName: '',
            selectedPlayerPos: '',
            selectedPlayerRealTeam: '',
            selectedPlayerHistory: null,
        };
        this.renderGameWeekSelect = this.renderGameWeekSelect.bind(this);
        this.computeBalance = this.computeBalance.bind(this);
        this.handlePlayerClick = this.handlePlayerClick.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    async handlePlayerClick(player) {
        this.setState({
            modalOpen: true,
            modalLoading: true,
            selectedPlayerName: player.name,
            selectedPlayerPos: player.pos,
            selectedPlayerRealTeam: player.team,
            selectedPlayerHistory: null,
        });
        try {
            const tournament = this.state.data.tournament;
            const leagueID = this.state.leagueID;
            const historyData = await getPlayerHistory(tournament, leagueID, player.id);
            this.setState({
                selectedPlayerHistory: historyData,
                modalLoading: false,
            });
        } catch (err) {
            console.error("Failed to load player history", err);
            this.setState({
                modalLoading: false,
            });
        }
    }

    handleModalClose() {
        this.setState({
            modalOpen: false,
        });
    }

    renderPlayerModal() {
        const { modalOpen, modalLoading, selectedPlayerName, selectedPlayerPos, selectedPlayerRealTeam, selectedPlayerHistory } = this.state;
        if (!modalOpen) return null;

        let content;
        if (modalLoading) {
            content = (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                    <CircularProgress />
                </div>
            );
        } else if (!selectedPlayerHistory) {
            content = (
                <div style={{ padding: '20px', color: 'red' }}>
                    Failed to load player performance history.
                </div>
            );
        } else {
            const gameWeekKeys = Object.keys(selectedPlayerHistory).filter(k => k.startsWith('gw'));
            gameWeekKeys.sort((a, b) => parseInt(b.replace('gw', '')) - parseInt(a.replace('gw', '')));

            const columns = [];
            gameWeekKeys.forEach(gw => {
                const gwData = selectedPlayerHistory[gw];
                const gwLabel = gw.toUpperCase();
                if (!gwData.matches || gwData.matches.length === 0) {
                    columns.push({
                        key: `${gw}-none`,
                        label: gwLabel,
                        score: 0,
                        explanations: [],
                    });
                } else if (gwData.matches.length === 1) {
                    columns.push({
                        key: `${gw}-${gwData.matches[0]}`,
                        label: gwLabel,
                        score: gwData.scores[0],
                        explanations: gwData.explanations[0] || [],
                    });
                } else {
                    gwData.matches.forEach((matchId, idx) => {
                        columns.push({
                            key: `${gw}-${matchId}`,
                            label: `${gwLabel} (M${idx + 1})`,
                            score: gwData.scores[idx],
                            explanations: gwData.explanations[idx] || [],
                        });
                    });
                }
            });

            columns.forEach(col => {
                col.batting = 0;
                col.bowling = 0;
                col.fielding = 0;
                col.bonuses = 0;
                col.explanations.forEach(exp => {
                    const parsed = parseExplanation(exp);
                    if (parsed.category === 'Batting') {
                        col.batting += parsed.points;
                    } else if (parsed.category === 'Bowling') {
                        col.bowling += parsed.points;
                    } else if (parsed.category === 'Fielding') {
                        col.fielding += parsed.points;
                    } else {
                        col.bonuses += parsed.points;
                    }
                });
                col.batting = parseFloat(col.batting.toFixed(2));
                col.bowling = parseFloat(col.bowling.toFixed(2));
                col.fielding = parseFloat(col.fielding.toFixed(2));
                col.bonuses = parseFloat(col.bonuses.toFixed(2));
            });

            content = (
                <div style={{ overflowX: 'auto' }}>
                    <Table size="small" style={{ minWidth: '450px' }}>
                        <TableBody>
                            <TableRow style={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                                <TableCell style={{ fontWeight: 'bold' }}>Category</TableCell>
                                {columns.map(col => (
                                    <TableCell key={col.key} align="right" style={{ fontWeight: 'bold' }}>
                                        {col.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell>Batting Points</TableCell>
                                {columns.map(col => (
                                    <TableCell key={col.key} align="right">
                                        {col.score === 0 && col.explanations.length === 0 ? '-' : col.batting.toFixed(2)}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell>Bowling Points</TableCell>
                                {columns.map(col => (
                                    <TableCell key={col.key} align="right">
                                        {col.score === 0 && col.explanations.length === 0 ? '-' : col.bowling.toFixed(2)}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell>Fielding Points</TableCell>
                                {columns.map(col => (
                                    <TableCell key={col.key} align="right">
                                        {col.score === 0 && col.explanations.length === 0 ? '-' : col.fielding.toFixed(2)}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell>Bonuses / Other</TableCell>
                                {columns.map(col => (
                                    <TableCell key={col.key} align="right">
                                        {col.score === 0 && col.explanations.length === 0 ? '-' : col.bonuses.toFixed(2)}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow style={{ fontWeight: 'bold', backgroundColor: 'rgba(16, 185, 129, 0.08)' }}>
                                <TableCell style={{ fontWeight: 'bold' }}>Total Score</TableCell>
                                {columns.map(col => (
                                    <TableCell key={col.key} align="right" style={{ fontWeight: 'bold', color: '#10b981' }}>
                                        {col.score.toFixed(2)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            );
        }

        return (
            <Dialog open={modalOpen} onClose={this.handleModalClose} maxWidth="md" fullWidth>
                <DialogTitle style={{ paddingBottom: '8px' }}>
                    <div style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>{selectedPlayerName}</div>
                    <div style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '4px' }}>
                        {selectedPlayerRealTeam} • {selectedPlayerPos}
                        {!modalLoading && selectedPlayerHistory && (
                            <span style={{ marginLeft: '16px', fontWeight: 'bold', color: '#1f5fbf' }}>
                                Total Points: {selectedPlayerHistory.totalScore.toFixed(2)}
                            </span>
                        )}
                    </div>
                </DialogTitle>
                <DialogContent dividers style={{ padding: '8px 16px 16px 16px' }}>
                    {content}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleModalClose} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    async componentDidMount() {
        const state = this.state;
        const data = await getTeam(state.leagueID, state.teamID);
        const scoreHeaders = Object.keys(data).filter(h => h.startsWith('gw'));
        const gw = scoreHeaders[0];
        this.setState(() => ({
            ...this.state,
            loading: false,
            data: data,
            team: gw === undefined ? [] : data[gw].players,
            gwScore: gw === undefined ? 0 : data[gw].score,
            balance: this.computeBalance(gw, data),
            gameWeek: gw,
            totalScore: data.totalScore,
        }));
    }

    handleGameWeekChange(e) {
        const gw = e.target.value;
        this.setState(() => ({
            ...this.state,
            team: this.state.data[gw].players,
            gwScore: this.state.data[gw].score,
            balance: this.computeBalance(gw, this.state.data),
            gameWeek: gw,
        }));
    }

    computeBalance(gw, data) {
        if (gw === undefined) {
            return '';
        }
        let balance = {
            'BAT': 0,
            'BOW': 0,
            'WK': 0,
        };
        data[gw].players.forEach(p => {
            if (p.pos === 'AR') {
                balance['BAT'] += 1;
                balance['BOW'] += 1;
            } else if (p.pos === 'WK') {
                balance['BAT'] += 1;
                balance['WK'] += 1;
            } else {
                balance[p.pos] += 1;
            }
        })
        return JSON.stringify(balance);
    }

    renderGameWeekSelect() {
        if (this.state.data === undefined) {
            return null;
        }
        const gameWeeks = Object.keys(this.state.data).filter(k => k.toLowerCase().startsWith('gw'));
        const selectDropDown = gameWeeks.length !== 0 ? (
            <Select labelId="choose gameweek" id='gameweek' value={this.state.gameWeek || gameWeeks[0]}
                onChange={(e) => this.handleGameWeekChange(e)}>
                {gameWeeks.map(gw => {
                    return <MenuItem key={gw} value={gw}>{gw.toUpperCase()}</MenuItem>
                })}
            </Select>
        ): (<div></div>)
        return (
            <TableRow key={'gameweek'}>
                <TableCell>GameWeek</TableCell>
                <TableCell>&nbsp;&nbsp;</TableCell>
                <TableCell>{selectDropDown}</TableCell>
            </TableRow>
        );
    }

    render() {
        return (
            <div style={{ 'display': 'flex', 'justifyContent': 'center', 'flexWrap': 'wrap', 'marginBottom': '50px', 
                'maxWidth': '600px', 'marginLeft': 'auto', 'marginRight': 'auto'}}>
                <Link to={`/leagues/${this.state.leagueID}`} style={{marginTop: '5px', 'flexGrow': 0}} >
                    <ArrowBackIcon />
                </Link>
                <Typography variant="h5" style={{'flexGrow': 1}}>
                    {this.state.teamID}
                </Typography>
                {this.state.loading && (
                    <div style={{'flexBasis': '100%'}}>
                        <CircularProgress />
                        <br />
                    </div>
                )}
                {
                    <div style={{display: 'flex-item', flexBasis: '100%', marginBottom: 20, marginTop: 20}}>
                    <Link to={`/leagues/${this.state.leagueID}/teams/${this.state.teamID}/squad`} style={{width: 200}}>
                    <Button variant='contained'>
                        Squad View
                    </Button>
                    </Link>
                    {this.state?.data?.isOwner &&
                    <Link to={`/leagues/${this.state.leagueID}/teams/${this.state.teamID}/captains`}
                        style={{width: 200, marginLeft: 20}}>
                    <Button variant='contained'>
                        Captains
                    </Button>
                    </Link>}
                    {this.state?.data?.isAdmin &&
                    <Link to={`/leagues/${this.state.leagueID}/teams/${this.state.teamID}/overwrite-xi`}
                        style={{width: 200, marginLeft: 20}}>
                    <Button variant='contained' color='secondary'>
                        Overwrite XI
                    </Button>
                    </Link>}
                    </div>
                }
                <TableContainer component={Paper} style={{ alignSelf: 'center', flex: 'auto', 'maxWidth': '600px'}}>
                    <Table>
                        <TableBody>
                            {this.state.totalScore !== undefined && <TableRow key={'totalScore'}>
                                <TableCell>Total Score</TableCell>
                                <TableCell>&nbsp;&nbsp;</TableCell>
                                <TableCell>{this.state.totalScore}</TableCell>
                            </TableRow>}
                            {this.renderGameWeekSelect()}
                            {this.state.gwScore !== undefined && <TableRow key={'gwScore'}>
                                <TableCell>GW Score</TableCell>
                                <TableCell>&nbsp;&nbsp;</TableCell>
                                <TableCell>{this.state.gwScore}</TableCell>
                            </TableRow>}
                            {this.state.gwScore !== undefined && <TableRow key={'balance'}>
                                <TableCell>Balance</TableCell>
                                <TableCell>&nbsp;&nbsp;</TableCell>
                                <TableCell>{this.state.balance}</TableCell>
                            </TableRow>}
                            {this.state.gwScore !== undefined && <TableRow key={'divider'}>
                                <TableCell>-----</TableCell>
                                <TableCell>-----</TableCell>
                                <TableCell>-----</TableCell>
                            </TableRow>}
                            {this.state.team.map((player, i) => {
                                const nameContent = player.name + (player.matchScores.length > 0 ? player.matchScores.map(o => o.captain ? ' (c) ' : '').reduce((p, c) => p + ',' + c) : '');
                                return (
                                    <PlayerRow key={i} player={player} nameContent={nameContent}
                                        onNameClick={() => this.handlePlayerClick(player)} />
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                {this.renderPlayerModal()}
            </div>
        );
    }
}
function PlayerRow({ player, nameContent, onNameClick }) {
    const [openMatch, setOpenMatch] = React.useState(null);

    const scoreStyle = {
        cursor: 'pointer',
        color: '#1f5fbf',
        textDecoration: 'underline',
        fontWeight: 500,
    };

    return (
        <TableRow>
            <TableCell>
                <button
                    type="button"
                    aria-label={`Show scoring breakdown for ${player.name}`}
                    style={{
                        padding: 0, border: 0, background: 'none',
                        cursor: 'pointer', color: '#1f5fbf',
                        textDecoration: 'underline', font: 'inherit', fontWeight: 500,
                    }}
                    onClick={onNameClick}
                >
                    {nameContent}
                </button>
            </TableCell>
            <TableCell>{`(${player.team} - ${player.pos})`}</TableCell>
            <TableCell>
                {player.matchScores.map((ms) => (
                    <div key={`score-${ms.matchId}`} style={scoreStyle} onClick={() => setOpenMatch(ms.matchId)}>
                        {ms.score}
                    </div>
                ))}
                {player.matchScores.map((ms) => (
                    <Dialog key={`dialog-${ms.matchId}`} open={openMatch === ms.matchId} onClose={() => setOpenMatch(null)}>
                        <DialogTitle>
                            {player.name} — Match {ms.matchId}
                            {ms.captain && <span style={{ marginLeft: 8, color: '#10b981', fontSize: '0.85rem' }}>
                                {' '}(captain multiplier applied)
                            </span>}
                        </DialogTitle>
                        <DialogContent dividers>
                            {(ms.explanation || []).map((e, i) => <div key={i}>{e}</div>)}
                            {ms.captain && (
                                <div style={{ marginTop: 8, fontWeight: 'bold', color: '#10b981' }}>
                                    Score after captain multiplier: {ms.score}
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenMatch(null)} color="primary" variant="contained">Close</Button>
                        </DialogActions>
                    </Dialog>
                ))}
            </TableCell>
        </TableRow>
    );
}

function safeEval(str) {
    const clean = str.replace(/[^0-9+\-*/(). ]/g, '');
    try {
        // eslint-disable-next-line no-new-func
        return Function(`"use strict"; return (${clean})`)();
    } catch (e) {
        return 0;
    }
}

export function parseExplanation(exp) {
    if (exp.includes('Rained out')) {
        return { category: 'Other', points: 0, detail: exp };
    }
    const colonIdx = exp.indexOf(':');
    if (colonIdx === -1) {
        return { category: 'Other', points: 0, detail: exp };
    }
    const prefix = exp.substring(0, colonIdx).trim();
    const rightPart = exp.substring(colonIdx + 1).trim();

    let points = 0;
    if (rightPart.includes('=')) {
        const afterEquals = rightPart.split('=').pop().trim();
        points = parseFloat(afterEquals);
    } else {
        points = safeEval(rightPart);
    }
    if (isNaN(points)) {
        points = 0;
    }

    let category = 'Other';
    const lowPrefix = prefix.toLowerCase();
    if (lowPrefix.includes('catch') || lowPrefix.includes('runout') || lowPrefix.includes('stump')) {
        category = 'Fielding';
    } else if (lowPrefix.includes('runs') || lowPrefix.includes('bound') || lowPrefix.includes('six') || lowPrefix.includes('duck') || lowPrefix.includes('strike') || lowPrefix.includes('position')) {
        category = 'Batting';
    } else if (lowPrefix.includes('wicket') || lowPrefix.includes('dot') || lowPrefix.includes('maid') || lowPrefix.includes('econ')) {
        category = 'Bowling';
    } else if (lowPrefix.includes('bonus')) {
        category = 'Bonuses';
    }

    return { category, points, detail: exp };
}

export default withRouter(SingleTeam);
